export const buyHome = {
	headerImg: null,
	header: "Buy a home",
	body: "Find your place with an immersive photo experience and the most listings, including things you won’t find anywhere else.",
	btnText: "Browse homes",
};

export const sellHome = {
	headerImg: null,
	header: "Sell a home",
	body: "No matter what path you take to sell your home, we can help you navigate a successful sale.",
	btnText: "See your options",
};

export const rentHome = {
	headerImg: null,
	header: "Rent a home",
	body: "We’re creating a seamless online experience – from shopping on the largest rental network, to applying, to paying rent.",
	btnText: "Find rentals",
};

//
